import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave, faSearch, faEye, faEyeSlash, faArrowUp, faArrowDown, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SitePlanner.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import axios from "axios"
import GoCast from '../../Images/GoCast.png'

function Site_Planner() {
    // Loading GIF
    const [isLoading, setIsLoading] = useState(false);
    // Search-bar
    const [searchOpen, setSearchOpen] = useState(false);
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);
    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed
    const [modifiedData, setModifiedData] = useState([]); // New state for modified data
    const [modifiedRows, setModifiedRows] = useState(new Set()); // New state to track modified rows
    const [filter, setFilter] = useState(''); // Element ID Filter

    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_ElementApproQtyBAQ_v1(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                // Initialize modifiedData with the fetched data
                setModifiedData(data.value.map(item => ({ ...item })));
                setIsLoading(false); // Load GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    // Save Data Using PATCH Method API
    const saveData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_ElementApproQtyBAQ_v1(PRECAST)';

        try {
            for (const rowIndex of modifiedRows) {
                const response = await axios.patch(apiUrl, modifiedData[rowIndex], {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
                setIsLoading(false); // Load GIF
            }
        } catch (error) {
            console.error('Error:', error.message);
            setIsLoading(false);
        }
    };

    const handleInputChange = (e, index, field) => {
        let newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        if (field === 'PartLot_ErectionPlannedDate_c' && e.target.type === 'date') {
            // Format the date to YYYY-MM-DDTHH:MM:SS
            const date = new Date(newValue);
            newValue = `${date.toISOString().split('T')[0]}T00:00:00`;
        }
        const newData = [...modifiedData];
        newData[index][field] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index))); // Add the index to modifiedRows set
    };

    const handleFilterChange = (e) => {
        const inputValue = e.target.value;
        setFilter(inputValue);

        // Filter apiData based on the input value, ensuring ElementID is defined
        const filteredData = apiData.filter(item => item.PartLot_PartNum && item.PartLot_PartNum.includes(inputValue));
        setModifiedData(filteredData.map(item => ({ ...item }))); // Update modifiedData with filtered data
    };

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, apiData.length); // Adjust endIndex
        const currentItems = apiData.slice(startIndex, endIndex);

        // Filter out undefined or null items to prevent errors
        const validItems = currentItems.filter(item => item !== undefined && item !== null);

        return validItems.map((item, index) => (
            <tr key={startIndex + index}>
                <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index]?.PartLot_Move_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Move_c')} /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_ErectionSequence_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_ErectionSequence_c')} /></td>
                <td><input className='UpdateInput' type="date" value={modifiedData[startIndex + index]?.PartLot_ErectionPlannedDate_c ? modifiedData[startIndex + index].PartLot_ErectionPlannedDate_c.split('T')[0] : ''} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_ErectionPlannedDate_c')} /></td>
                <td>{modifiedData[startIndex + index]?.PartLot_LotNum}</td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_PartNum} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_PartNum')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_PartLotDescription} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_PartLotDescription')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_TypicalID_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_TypicalID_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_Project_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Project_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_Length_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Length_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_Width_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Width_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_Height_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Height_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_M3_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_M3_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_M2_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_M2_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_Ton_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Ton_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_BuildingType_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_BuildingType_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_BuildingNumber_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_BuildingNumber_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_Floor_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_Floor_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_JobNum_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_JobNum_c')} /></td>
                <td><input disabled className='UpdateInput' type="text" value={modifiedData[startIndex + index]?.PartLot_ActualCastedDate_c} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_ActualCastedDate_c')} /></td>
            </tr>
        ));
    };

    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Search Toggle
    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }

    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }

    return (
        <div className='APretention'>
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className='card rebartable'>
                <div className="card-header-apretention">
                    {/* <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                        <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                    </button> */}
                    {/* <h2 className='panel-title-site'>Site Planner Dashboard</h2> */}
                    <div className='Element-id-container-site'>
                        <input type='text' placeholder='Part' className='Search-Input' onChange={handleFilterChange} />
                    </div>
                    <div className='ctrl-btns-siteplanner'>
                        <button className="btn" id='add'>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='save' onClick={saveData}>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#save"
                            content="Save"
                            place='bottom'
                        />
                        {/* <button type="button" className="search-icon" onClick={toggleSearch}>
                            <FontAwesomeIcon icon={faSearch} />
                        </button>
                        <Tooltip
                            anchorSelect=".search-icon"
                            content="Advanced Search"
                            place='bottom'
                        /> */}
                        {/* <div className="table-responsive">
                            <div className={`main-search-bar ${searchOpen ? 'open' : ''}`} id="searchBar">
                                <form className="search-filter">
                                    <h3 className="search-title">Search Filter <FontAwesomeIcon icon={faSearch} /></h3>
                                    <input type="text" placeholder="Element ID" name="filter1" />
                                    <input type="text" placeholder="Project" name="filter2" />
                                    <input type="text" placeholder="Part" name="filter3" />
                                    <select
                                        className="wbs-combo"
                                        type="text"
                                        name="optionlist"
                                        onChange={(e) => console.log(e.target.value)}
                                    >
                                        <option value="" selected disabled>WBS</option>
                                        <option>WBS 1</option>
                                        <option>WBS 2</option>
                                        <option>option 3</option>
                                        <option>option 4</option>
                                        <option>option 5</option>
                                    </select>
                                    <button type="submit">Search</button>
                                    <button type="reset" onClick={toggleSearch}>Cancel</button>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* Conditionally render the table */}
                {tableVisible && (
                    <div className="card-body" style={{ overflowY: 'scroll' }}>
                        <div class="table-responsive-sm">
                            <div className="scrollable-table-body">
                                <table className="table table-bordered">
                                    {/* Table content */}
                                    <thead className='table-primary'>
                                        <tr className='bg-primary text-white text-nowrap'>
                                            <th>Move</th>
                                            <th>Erection Sequence</th>
                                            <th>Erection Planned Date</th>
                                            <th>Element ID</th>
                                            <th>Part</th>
                                            <th>Description</th>
                                            <th>Typical ID</th>
                                            <th>Project</th>
                                            <th>Length</th>
                                            <th>Width</th>
                                            <th>Height</th>
                                            <th>Volume</th>
                                            <th>Area</th>
                                            <th>Weight</th>
                                            <th>ID1</th>
                                            <th>ID2</th>
                                            <th>ID3</th>
                                            <th>Job Num</th>
                                            <th>Actual Casted Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderTableRows()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="pagination">
                            <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>

                    </div>

                )}
            </div>
        </div>
    );
}

export default Site_Planner;
